<template>
  <v-app style="background-color: #f8f9fb">
    <v-dialog v-model="showProgress" persistent max-width="320">
      <v-card>
        <v-card-title>{{ progressTitle }}</v-card-title>
        <v-card-text>
          <v-progress-linear indeterminate color="primary"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-container
      style="background-color: #eee"
      id="relatorios-seguro"
      fluid
      tag="section"
    >
      <v-row>
        <v-col cols="12">
          <base-material-card
            icon="mdi-shield-star"
            title="Relatórios Seguro"
            color="green"
            style="margin-top: 20px !important; padding-top: 10px !important"
            class="px-5 py-4"
          >
            <v-card class="pa-4 mx-4 filtro-seguro-card" elevation="0">
              <v-row dense align="start" class="filtro-seguro-row">
                <v-col cols="12" sm="6" :md="isPrestamista ? 4 : 3" lg="2">
                  <span>Tipo de Consulta</span>
                  <v-select
                    v-model="selectedReport"
                    :items="reportOptions"
                    item-text="text"
                    item-value="value"
                    label="Tipo de Consulta"
                    dense
                    solo-inverted
                    @change="handleReportChange"
                  ></v-select>
                </v-col>

                <v-col v-if="isPrestamista" cols="12" sm="6" md="4" lg="3">
                  <span>Data de Corte</span>
                  <v-menu
                    v-model="isDataCortePickerOpen"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                  >
                    <template #activator="{ on }">
                      <v-text-field
                        v-model="selectedDataCorte"
                        label="Data de Corte"
                        dense
                        solo-inverted
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="params.dataCorte"
                      no-title
                      locale="pt-br"
                      type="date"
                      @input="handleDataCorteSelection"
                    ></v-date-picker>
                  </v-menu>
                </v-col>

                <v-col v-if="isPrestamista" cols="12" sm="6" md="4" lg="3">
                  <span>Empresa</span>
                  <v-select
                    v-model="params.idEmpresa"
                    :items="empresasSeguro"
                    item-text="text"
                    item-value="value"
                    label="Empresa"
                    dense
                    solo-inverted
                  ></v-select>
                </v-col>

                <v-col v-if="!isPrestamista" cols="12" sm="6" md="4" lg="3">
                  <span>Empresa</span>
                  <v-select
                    v-model="params.empresaRelatorio"
                    :items="empresas"
                    item-text="text"
                    item-value="value"
                    label="Empresa"
                    dense
                    solo-inverted
                    clearable
                    @change="handleEmpresaRelatorioChange"
                  ></v-select>
                </v-col>

                <v-col v-if="showContratoSeguro" cols="12" sm="6" md="4" lg="3">
                  <span>Contrato</span>
                  <v-select
                    v-model="params.contratoSeguro"
                    :items="contratosSeguro"
                    item-text="text"
                    item-value="value"
                    label="Contrato"
                    dense
                    solo-inverted
                  ></v-select>
                </v-col>

                <v-col
                  v-if="!isPrestamista"
                  cols="12"
                  sm="6"
                  md="4"
                  lg="2"
                  title="Data Final Contrato"
                >
                  <span>Data Final Contrato</span>
                  <v-menu
                    v-model="isDataFinalContratoPickerOpen"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                  >
                    <template #activator="{ on }">
                      <v-text-field
                        v-model="selectedDataFinalContrato"
                        label="Data Final de Contrato"
                        dense
                        solo-inverted
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="params.dataFinalContrato"
                      no-title
                      locale="pt-br"
                      type="date"
                      @input="handleDataFinalContratoSelection"
                    ></v-date-picker>
                  </v-menu>
                </v-col>

                <v-col
                  v-if="!isPrestamista"
                  cols="12"
                  sm="6"
                  md="4"
                  lg="2"
                  title="Data Inicial Falecimento"
                >
                  <span>Data Inicial Falecimento</span>
                  <v-menu
                    v-model="isDataInicialFalecimentoPickerOpen"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                  >
                    <template #activator="{ on }">
                      <v-text-field
                        v-model="selectedDataInicialFalecimento"
                        label="Data Inicial de Falecimento"
                        dense
                        solo-inverted
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="params.dataInicialFalecimento"
                      no-title
                      locale="pt-br"
                      type="date"
                      @input="handleDataInicialFalecimentoSelection"
                    ></v-date-picker>
                  </v-menu>
                </v-col>

                <v-col
                  v-if="!isPrestamista"
                  cols="12"
                  sm="6"
                  md="4"
                  lg="2"
                  title="Meses de Inadimplência"
                >
                  <span>Inadimplência</span>
                  <v-text-field
                    v-model.number="params.mesesInad"
                    label="Meses de Inadimplência"
                    type="number"
                    dense
                    solo-inverted
                    :min="0"
                    :max="100"
                  ></v-text-field>
                </v-col>

              </v-row>

              <v-row dense class="mt-1">
                <v-col cols="12" class="d-flex justify-end">
                  <v-btn
                    color="primary"
                    elevation="2"
                    height="36"
                    min-width="150"
                    class="text-capitalize font-weight-bold"
                    :loading="loading"
                    @click="consultarDados"
                  >
                    <v-icon left>mdi-magnify</v-icon>
                    Buscar
                  </v-btn>
                </v-col>
              </v-row>
            </v-card>

            <v-card class="pa-4 mx-4 mt-4" elevation="0">
              <v-alert v-if="errorMessage" type="error" dense outlined>
                {{ errorMessage }}
              </v-alert>

              <v-row align="center" class="mb-2">
                <v-col cols="12" md="8">
                  <div class="font-weight-bold">{{ selectedReportLabel }}</div>
                  <div class="text-caption grey--text text--darken-1">
                    {{ registros.length }} registro(s) encontrado(s)
                  </div>
                </v-col>
              </v-row>

              <v-data-table
                :headers="headers"
                :items="registros"
                :loading="loading"
                :items-per-page="10"
                class="elevation-0 table"
                dense
                fixed-header
                no-data-text="Nenhum registro encontrado"
                loading-text="Carregando registros..."
              >
                <template v-slot:item="{ item, index }">
                  <tr :class="index % 2 === 0 ? 'linha-par' : 'linha-impar'">
                    <td
                      v-for="header in headers"
                      :key="header.value"
                      class="table-texto"
                    >
                      {{ formatValue(getCellValue(item, header)) }}
                    </td>
                  </tr>
                </template>
              </v-data-table>

              <v-row align="center" class="mb-2">
                <v-col cols="12" md="8"> </v-col>
                <v-col cols="12" md="4" class="d-flex justify-end">
                  <span
                    style="
                      color: green;
                      font-size: 48px;
                      margin-right: 12px;
                      cursor: pointer;
                    "
                    @click="download_xls"
                  >
                    <i class="fas fa-file-excel"></i>
                  </span>
                </v-col>
              </v-row>
            </v-card>
          </base-material-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import GestaoCarteiraService from "../../services/gestaoCarteira";
import downloadBlob from "../../services/downloadBlob";

export default {
  name: "RelatoriosSeguro",
  data() {
    const hoje = new Date();
    const primeiroDiaDoMes = new Date(hoje.getFullYear(), hoje.getMonth(), 1)
      .toISOString()
      .slice(0, 10);
    const primeiroDiaMesAnterior = new Date(
      hoje.getFullYear(),
      hoje.getMonth() - 1,
      1
    )
      .toISOString()
      .slice(0, 10);
    const ultimoDiaMesAnterior = new Date(
      hoje.getFullYear(),
      hoje.getMonth(),
      0
    )
      .toISOString()
      .slice(0, 10);

    const primeiraEmpresa = "PREVIDA";

    return {
      loading: false,
      downloading: false,
      showProgress: false,
      progressTitle: "Baixando arquivo...",
      errorMessage: "",
      selectedReport: "prestamista",
      reportOptions: [
        { text: "Prestamista", value: "prestamista" },
        { text: "VG", value: "vg" },
        { text: "Remissivo", value: "remissivo" },
      ],
      empresasSeguro: [
        { text: "MEMORIAL PARQUE", value: 3 },
        { text: "CEMITERIO PREVIDA SAO MIGUEL", value: 20 },
      ],
      params: {
        dataCorte: primeiroDiaDoMes,
        idEmpresa: 3,
        empresaRelatorio: primeiraEmpresa,
        contratoSeguro: 1,
        dataFinalContrato: ultimoDiaMesAnterior,
        dataInicialFalecimento: primeiroDiaMesAnterior,
        mesesInad: 1,
      },
      selectedDataCorte: "",
      selectedDataFinalContrato: "",
      selectedDataInicialFalecimento: "",
      isDataCortePickerOpen: false,
      isDataFinalContratoPickerOpen: false,
      isDataInicialFalecimentoPickerOpen: false,
      headers: [],
      registros: [],
      empresas: [
        {
          text: "CEMITERIO PREVIDA",
          value: "CEMITERIO PREVIDA",
          dataCorteContrato: "2026-08-01",
          contratoPadrao: 1,
        },
        {
          text: "CEMITERIO PREVIDA SÃO MIGUEL",
          value: "CEMITERIO PREVIDA SÃO MIGUEL",
          dataCorteContrato: null,
          contratoPadrao: 1,
        },
        {
          text: "MEMORIAL PARQUE MACEIÓ",
          value: "MEMORIAL PARQUE MACEIÓ",
          dataCorteContrato: null,
          contratoPadrao: 1,
        },
        {
          text: "PARQUE DO AGRESTE",
          value: "PARQUE DO AGRESTE",
          dataCorteContrato: null,
          contratoPadrao: 1,
        },
        {
          text: "PREVIDA",
          value: "PREVIDA",
          dataCorteContrato: "2026-08-01",
          contratoPadrao: 1,
        },
        {
          text: "PARQUE DAS FLORES",
          value: "PARQUE DAS FLORES",
          dataCorteContrato: "2026-08-01",
          contratoPadrao: 1,
        },
      ],
      contratosSeguro: [
        { text: "FAIXA ETÁRIA (NOVO)", value: 1 }, 
        { text: "TIPO DE CONTRATO", value: 2 },
      ],
      reportHeaders: {
        prestamista: [
          { text: "NOME", value: "nome" },
          { text: "DATA DE NASCIMENTO", value: "dataNascimento" },
          { text: "CPF", value: "cpf" },
          { text: "CAPITAL", value: "capital" },
          { text: "TAXA", value: "taxa" },
          { text: "MATRÍCULA", value: "matricula" },
          { text: "INÍCIO DO FINANCIAMENTO", value: "inicioFinanciamento" },
          { text: "PRAZO DE FINANCIAMENTO", value: "prazoFinanciamento" },
        ],
      },
    };
  },

  computed: {
    isPrestamista() {
      return this.selectedReport === "prestamista";
    },
    selectedReportLabel() {
      const report = this.reportOptions.find(
        (option) => option.value === this.selectedReport
      );
      return report ? report.text : "";
    },
    selectedEmpresaRelatorio() {
      return this.empresas.find(
        (empresa) => empresa.value === this.params.empresaRelatorio
      );
    },
    dataCorteContrato() {
      return this.selectedEmpresaRelatorio
        ? this.selectedEmpresaRelatorio.dataCorteContrato
        : null;
    },
    showContratoSeguro() {
      return !this.isPrestamista && Boolean(this.dataCorteContrato);
    },
    contratoPadraoSeguro() {
      return this.selectedEmpresaRelatorio && this.selectedEmpresaRelatorio.contratoPadrao
        ? this.selectedEmpresaRelatorio.contratoPadrao
        : 1;
    },
  },

  mounted() {
    this.params.contratoSeguro = this.contratoPadraoSeguro;
    this.selectedDataCorte = this.convertToBR(this.params.dataCorte);
    this.selectedDataFinalContrato = this.convertToBR(
      this.params.dataFinalContrato
    );
    this.selectedDataInicialFalecimento = this.convertToBR(
      this.params.dataInicialFalecimento
    );
    this.headers = this.getHeadersForReport();
  },

  methods: {
    handleReportChange() {
      this.errorMessage = "";
      this.params.empresaRelatorio = null;
      this.params.contratoSeguro = 1;
      this.headers = this.getHeadersForReport();
      this.registros = [];
    },
    handleEmpresaRelatorioChange() {
      this.errorMessage = "";
      this.params.contratoSeguro = this.contratoPadraoSeguro;
      this.headers = this.getHeadersForReport();
      this.registros = [];
    },
    consultarDados() {
      if (!this.validarParametros()) {
        return;
      }

      this.loading = true;
      this.errorMessage = "";
      GestaoCarteiraService.consultarRelatorioSeguro(
        this.selectedReport,
        this.buildParams()
      )
        .then((response) => {
          const dados = Array.isArray(response.data) ? response.data : [];
          this.registros = dados;
          this.headers = this.getHeadersForReport(dados);
        })
        .catch((error) => {
          console.error(error);
          this.errorMessage = "Erro ao consultar o relatorio.";
        })
        .finally(() => {
          this.loading = false;
        });
    },
    download_xls() {
      if (!this.validarParametros()) {
        return;
      }

      this.downloading = true;
      this.showProgress = true;
      this.errorMessage = "";
      GestaoCarteiraService.downloadRelatorioSeguro(
        this.selectedReport,
        this.buildParams()
      )
        .then((response) => {
          const fileName = this.getDownloadFileName(response);
          downloadBlob(new Blob([response.data]), fileName);
        })
        .catch((error) => {
          console.error(error);
          this.errorMessage = "Erro ao baixar o arquivo Excel.";
        })
        .finally(() => {
          this.downloading = false;
          this.showProgress = false;
        });
    },
    buildParams() {
      if (this.isPrestamista) {
        return {
          "data-corte": this.params.dataCorte,
          empresa: this.params.idEmpresa,
        };
      }

      return {
        "data-final-contrato": this.params.dataFinalContrato,
        "data-inicial-falecimento": this.params.dataInicialFalecimento,
        "meses-inad": this.params.mesesInad,
        empresa: this.params.empresaRelatorio,
        contrato: this.showContratoSeguro
          ? this.params.contratoSeguro
          : this.contratoPadraoSeguro,
        "data-corte-contrato": this.dataCorteContrato || undefined,
      };
    },
    validarParametros() {
      if (!this.selectedReport) {
        this.errorMessage = "Selecione o tipo de consulta.";
        return false;
      }

      if (this.isPrestamista) {
        if (!this.params.dataCorte || !this.params.idEmpresa) {
          this.errorMessage = "Informe a data de corte e a empresa.";
          return false;
        }
        return true;
      }

      if (
        !this.params.dataFinalContrato ||
        !this.params.dataInicialFalecimento ||
        !this.params.empresaRelatorio
      ) {
        this.errorMessage =
          "Informe a data final de contrato, a data inicial de falecimento e a empresa.";
        return false;
      }

      if (this.showContratoSeguro && !this.params.contratoSeguro) {
        this.errorMessage = "Informe o contrato.";
        return false;
      }

      return true;
    },
    getHeadersForReport(registros = this.registros) {
      const headers = this.isPrestamista
        ? this.reportHeaders[this.selectedReport] || []
        : this.buildDynamicHeaders(registros);

      return headers.map((header) => ({
        ...header,
        sortable: true,
      }));
    },
    buildDynamicHeaders(registros) {
      const campos = [];
      const camposAdicionados = new Set();

      registros.forEach((registro) => {
        Object.keys(registro || {}).forEach((campo) => {
          if (!camposAdicionados.has(campo)) {
            camposAdicionados.add(campo);
            campos.push(campo);
          }
        });
      });

      return campos.map((campo) => ({
        text: this.formatHeaderLabel(campo),
        value: campo,
      }));
    },
    formatHeaderLabel(campo) {
      return String(campo)
        .replace(/_/g, " ")
        .replace(/([a-z])([A-Z])/g, "$1 $2")
        .toUpperCase();
    },
    getCellValue(item, header) {
      const keys = [header.value].concat(header.aliases || []);

      for (const key of keys) {
        if (Object.prototype.hasOwnProperty.call(item, key)) {
          return item[key];
        }
      }

      return "";
    },
    getDownloadFileName(response) {
      const disposition =
        response.headers && response.headers["content-disposition"];
      const match = disposition && disposition.match(/filename="?([^";]+)"?/i);

      if (match && match[1]) {
        return match[1];
      }

      return `${this.selectedReport}_${Date.now()}.xlsx`;
    },
    formatValue(value) {
      if (value === null || value === undefined) {
        return "";
      }

      if (typeof value === "number") {
        return value.toLocaleString("pt-BR");
      }

      return value;
    },
    handleDataCorteSelection() {
      this.selectedDataCorte = this.convertToBR(this.params.dataCorte);
      this.isDataCortePickerOpen = false;
    },
    handleDataFinalContratoSelection() {
      this.selectedDataFinalContrato = this.convertToBR(
        this.params.dataFinalContrato
      );
      this.isDataFinalContratoPickerOpen = false;
    },
    handleDataInicialFalecimentoSelection() {
      this.selectedDataInicialFalecimento = this.convertToBR(
        this.params.dataInicialFalecimento
      );
      this.isDataInicialFalecimentoPickerOpen = false;
    },
    convertToBR(dateString) {
      if (!dateString) {
        return "";
      }

      const [year, month, day] = dateString.split("-");
      return `${day}/${month}/${year}`;
    },
  },
};
</script>
<style scoped>
.linha-par {
  background-color: #ffffff;
}

.linha-impar {
  background-color: rgb(231 244 255);
}

.table-texto {
  font-size: 12px !important;
  padding-top: 4px !important;
  padding-bottom: 4px !important;
}

.table ::v-deep th {
  font-size: 12px !important;
}

.table ::v-deep td {
  font-size: 12px !important;
}

.filtro-seguro-card {
  border-radius: 6px;
}

.filtro-seguro-row {
  row-gap: 4px;
}

.filtro-seguro-card span {
  display: block;
  min-height: 18px;
  margin-bottom: 4px;
  color: #4f5b62;
  font-size: 12px;
  font-weight: 600;
}

.filtro-seguro-card ::v-deep .v-input {
  font-size: 12px;
}

.filtro-seguro-card ::v-deep .v-text-field.v-text-field--solo .v-input__control {
  min-height: 34px;
}

.filtro-seguro-card ::v-deep .v-select__selection {
  max-width: 100%;
}

.filtro-seguro-card ::v-deep .v-select__selection--comma {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
